'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoFlag = function IoFlag(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.3 14.2s0.9-0.1 1.7-0.4c0 1.2-0.5 2.5-0.7 2.8-2.2 3.9-7.7 9.6-14.1 6.5-5.1-2.4-7.2-2.3-9.2-1.8-0.1 0-0.1 0-0.2 0-0.3 0.1-1.2 0.4-2 0.1v-15.4c0-1.2 1-2.4 2.5-2.7 3.1-0.6 8.3-0.4 11.6 5.8 3 5.7 7.6 5.6 10.4 5.1z m-26.4-11.7c0.3 0 0.6 0.3 0.6 0.6v33.8c0 0.3-0.3 0.6-0.6 0.6h-1.3c-0.3 0-0.6-0.3-0.6-0.6v-33.8c0-0.3 0.3-0.6 0.6-0.6h1.3z' })
        )
    );
};

exports.default = IoFlag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/flag.js
// module id = 2261
// module chunks = 0